import React, { useCallback, useMemo } from 'react'
import { Row, Col, Label } from 'reactstrap'
import { Icon } from 'components/icons'
import MuiButton from '@material-ui/core/Button'
import { useStyles } from './index.css'
import { WsetEvaluationItem } from './item'
import { wsetType as wsetTypeEnum} from 'enums/wsetType'

const findFirstNotUsedWsetType = (wsetEvaluations) => {
  let wsetType = -1
  const { values } = wsetTypeEnum
  values.forEach(type => {
    if (wsetType === -1) {
      if (!wsetEvaluations.find(x => x.wsetType === type)) {
        wsetType = type
      }
    }
  })
  return wsetType
}

export const WsetEvaluations = (props) => {
  const classes = useStyles()

  const { localize, updateEntity, entity, disabled, isInDialog } = props
  const { wsetEvaluations } = entity
  const { values : wsetTypeValues } = wsetTypeEnum

  const handleAddClick = useCallback(() => {
    const wsetType = findFirstNotUsedWsetType(wsetEvaluations)
    
    const newEvaluations = [...wsetEvaluations, { wsetType, value: 0 }]
    updateEntity('wsetEvaluations')(newEvaluations)
  }, [updateEntity, wsetEvaluations])

  const handleUpdate = useCallback(({ wsetEvaluation, index }) => {
    const newItems = wsetEvaluations.map((x, idx) => idx === index ? wsetEvaluation : x).filter(x => x)
    updateEntity('wsetEvaluations')(newItems)
  }, [updateEntity, wsetEvaluations])

  const isAddButtonDisabled = useMemo(() => disabled || wsetEvaluations.length >= wsetTypeValues.length, [disabled, wsetEvaluations, wsetTypeValues])

  return (
    <div className={classes.root}>
      <Row>
        <Col sm={12}>
          <Label>{localize('wines.wsetEvaluationsTitle')}</Label>
          <div className={classes.addButton}>
            <MuiButton
              className={classes.button}
              variant='contained'
              disabled={isAddButtonDisabled}
              title={localize('wines.addWineEvaluation')}
              color='primary'
              onClick={handleAddClick}><Icon name={'plus'} /></MuiButton>
          </div>
        </Col>
      </Row>
      <Row>
        {entity.wsetEvaluations.map((x, idx) => 
          <WsetEvaluationItem 
            key={`item_${idx}`} 
            entity={x}
            wsetEvaluations={entity.wsetEvaluations}
            localize={localize} 
            index={idx} 
            onUpdate={handleUpdate} 
            canRemove={idx === entity.wsetEvaluations.length - 1}
            disabled={disabled}
            isInDialog={isInDialog}
          />)}
      </Row>
    </div>
  )
}